import { supabase } from "../supabaseClient";
import { decode } from "base64-arraybuffer";
import { errorTost, offlineToast } from "./Toast";
import { Network } from "@capacitor/network";

async function loginWithEmailPass(email, password) {
  console.log({ email, password });
  const { data, error } = await supabase.auth.signIn({
    email: email,
    password: password,
  });
  if (data) return data;
  else throw error;
}
async function checkIsEmailExist(type, id) {
  var query;
  if (type === "FOS") {
    query = await supabase.from("FOS").select("*").eq("fosDisplayId", id);
  } else {
    query = await supabase
      .from("CP")
      .select("*,CpContactPerson!left(email)")
      .eq("cpDisplayId", id);
  }
  const { data, error } = query;
  if (data) return data;
  else throw error;
}
// !!For forget Password
async function checkIsEmailExistFP(type, id) {
  var query;
  if (type === "FOS") {
    query = await supabase.from("FOS").select("*").eq("fosDisplayId", id);
  } else {
    query = await supabase
      .from("CP")
      .select("*,CpContactPerson!left(*)")
      .eq("cpDisplayId", id);
  }
  const { data, error } = query;
  if (data) return data;
  else throw error;
}
async function getSalesPerson(name) {
  const { data, error } = await supabase
    .from("Users")
    .select("userId,name")
    .ilike("name", `%${name}%`);
  if (data) return data;
  else throw error;
}
async function checkCPIsAprroved(id) {
  const { data, error } = await supabase
    .from("CpContactPerson")
    .select("*,cpId(*)")
    .eq("cpContactPersonId", id);
  if (data) return data;
  else throw error;
}
async function updateRecommentdationToFoSTable(cpId, fosId) {
  const { data, error } = await supabase
    .from("FOS")
    .update({ cpId: cpId, last_updated_at: Date.now() })
    .eq("fosId", fosId);
  if (data) return data;
  else throw error;
}
async function updatePasswordFlag(flag, type, id) {
  if (type === "CP") {
    const { data, error } = await supabase
      .from("CP")
      .update({ isPasswordUpdated: flag, last_updated_at: Date.now() })
      .eq("cpId", id);
    if (data) return data;
    else throw error;
  } else if (type === "FOS") {
    const { data, error } = await supabase
      .from("FOS")
      .update({ isPasswordUpdated: flag, last_updated_at: Date.now() })
      .eq("fosId", id);
    if (data) return data;
    else throw error;
  }
}
// async function signUpCP(cpDetails, personalDetail, bankDetails, cpType) {

//   const { user, error } = await supabase.auth.signUp({
//     email: personalDetail.email.toLowerCase(),
//     password: personalDetail.password
//   },
//     {
//       data: {
//         type: "CP",
//         isGSTApplicable: cpDetails.gstApplicable,
//         billingName: cpDetails.billingName.toUpperCase().replace(/\s\s+/g, ' '),
//         msmeType: cpDetails.msmeAvalaible,
//         msmeNumber: cpDetails.msmeNumber,
//         cpType: cpType,
//         bankAccountHolderName: bankDetails.holderName.toUpperCase().replace(/\s\s+/g, ' '),
//         bankAccountNumber: bankDetails.accountNumber,
//         bankIFSCCode: bankDetails.ifscCode,
//         bankBranchName: bankDetails.branchName,
//         name: personalDetail.personaName.toUpperCase().replace(/\s\s+/g, ' '),
//         contactNumber: personalDetail.phoneNumber,
//         isFlagged: cpDetails.isFlagged,
//         recommendedBySalesId: cpDetails.recomendation.value,
//         // isPasswordUpdated: null      // ! default null handled in supabase table
//       }
//     })
//   if (user) return user;
//   else throw error;
// }

async function signUpCP(
  cpDetails,
  personalDetail,
  bankDetails,
  cpType,
  reraEndDate,
  reraStartDate,
  agentType
) {
  console.log(cpDetails, "cp details");
  console.log(personalDetail, "persondetails");
  console.log(bankDetails, "bankdetails");
  console.log(cpType, "cptypeeeee");
  console.log("reraEndDate", reraEndDate);
  console.log("reraStartDate", reraStartDate);
  console.log("agentType", agentType);

  const { user, error } = await supabase.auth.signUp(
    {
      email: personalDetail.email.toLowerCase(),
      password: personalDetail.password,
    },
    {
      data: {
        type: "CP",
        isGSTApplicable: cpDetails.gstApplicable,
        billingName: cpDetails.billingName.toUpperCase().replace(/\s\s+/g, " "),
        msmeType: cpDetails.msmeAvalaible,
        msmeNumber: cpDetails.msmeNumber,
      cpType: cpDetails?.reraExtracted?.cpType || cpType,
       typeOfAgent: cpDetails?.reraExtracted?.typeOfAgent || agentType,
       reraStartDate: cpDetails?.reraExtracted?.startDate || reraStartDate,
      reraEndDate: cpDetails?.reraExtracted?.endDate || reraEndDate,
      gstBusinessName: cpDetails?.gstObject?.business_name || null,
      gstLegalName: cpDetails?.gstObject?.legal_name || null,
      proprietorship_name: cpDetails?.proprietorshipName || null,


        bankAccountHolderName: bankDetails.holderName
          .toUpperCase()
          .replace(/\s\s+/g, " "),
        bankAccountNumber: bankDetails.accountNumber,
        bankIFSCCode: bankDetails.ifscCode,
        bankBranchName: bankDetails.branchName,
        name: personalDetail.personaName.toUpperCase().replace(/\s\s+/g, " "),
        contactNumber: personalDetail.phoneNumber,
        isFlagged: cpDetails.isFlagged,
        recommendedBySalesId: cpDetails.recomendation.value,
        // isPasswordUpdated: null      // default handled in Supabase
      },
    }
  );
  console.log("user=========>", user);
  console.log("error=====>", error);
  if (user) return user;
  else throw error;
}


async function signUpStaticCP() {
  const { user, error } = await supabase.auth.signUp(
    {
      email: "khankamal5555@gmail.com",
      password: "Kamal123",
    },
    {
      data: {
        type: "CP",
        isGSTApplicable: false,
        billingName: "KAMAAL HAMIDULLAH KHAN",
        msmeType: "Not Applicable",
        msmeNumber: null,
        cpType: "Individual",
        bankAccountHolderName: "MR. KHAN KAMAAL HAMI",
        bankAccountNumber: 10069291451,
        bankIFSCCode: "IDFB0041433",
        bankBranchName: "Balewadi",
        name: "KAMAAL KHAN",
        contactNumber: 9082004094,
        isFlagged: true,
        recommendedBySalesId: null,
        // isPasswordUpdated: null      // ! default null handled in supabase table
      },
    }
  );
  if (user) return user;
  else throw error;
}

async function getCpId(id) {
  const { data, error } = await supabase
    .from("CpContactPerson")
    .select("cpId,cpContactPersonId")
    .eq("cpContactPersonId", id);
  if (data) return data;
  else throw error;
}

async function addKYCDoc(cpId, cpDetails, gstApplicable) {
  console.log({ cpDetails }, gstApplicable);
  var query;
  if (gstApplicable === true || gstApplicable === "true") {
    query = await supabase.from("KycDocuments").insert([
      {
        cpId: cpId,
        docType: "Rera",
        docNumber: cpDetails.reraNumber.toUpperCase().replace(/\s\s+/g, " "),
        docHolderName: cpDetails.reraObject.details[0].agent_name
          .toUpperCase()
          .replace(/\s\s+/g, " "),
        docUrl: cpDetails.docUrl,
        otherDetails: cpDetails.reraObject.details[0],
      },
      {
        cpId: cpId,
        docType: "PanCard",
        docNumber: cpDetails.panNumber.toUpperCase().replace(/\s\s+/g, " "),
        docHolderName: cpDetails.panObject.full_name
          .toUpperCase()
          .replace(/\s\s+/g, " "),
        docUrl: "",
        otherDetails: cpDetails.panObject,
      },
      {
        cpId: cpId,
        docType: "GST",
        docNumber: cpDetails.gstNumber.toUpperCase(),
        docHolderName: cpDetails.gstObject.business_name
          .toUpperCase()
          .replace(/\s\s+/g, " "),
        docUrl: "",
        otherDetails: cpDetails.gstObject,
      },
    ]);
  } else {
    query = await supabase.from("KycDocuments").insert([
      {
        cpId: cpId,
        docType: "Rera",
        docNumber: cpDetails?.reraNumber,
        docHolderName: cpDetails?.reraObject?.details[0].agent_name
          ?.toUpperCase()
          .replace(/\s\s+/g, " "),
        docUrl: cpDetails?.docUrl,
        otherDetails: cpDetails?.reraObject.details[0],
      },
      {
        cpId: cpId,
        docType: "PanCard",
        docNumber: cpDetails?.panNumber?.toUpperCase().replace(/\s\s+/g, " "),
        docHolderName: cpDetails?.panObject?.full_name
          ?.toUpperCase()
          .replace(/\s\s+/g, " "),
        docUrl: "",
        otherDetails: cpDetails?.panObject,
      },
    ]);
  }
  const { data, error } = query;
  if (data) return data;
  else throw error;
}

//FOS
async function checkFOSIsAprroved(id) {
  const { data, error } = await supabase
    .from("FOS")
    .select("*,cpId!left(*)")
    .eq("fosId", id);
  if (data) return data;
  else throw error;
}
async function signUpFos(personalDetail, bankDetails, cpId) {
  const { user, error } = await supabase.auth.signUp(
    {
      email: personalDetail.email.toLowerCase(),
      password: personalDetail.password,
    },
    {
      data: {
        type: "FOS",
        cpId: cpId,
        name: personalDetail.name.toUpperCase().replace(/\s\s+/g, " "),
        contactNumber: personalDetail.phoneNumber,
        bankAccountHolderName: bankDetails.holderName,
        bankAccountNumber: bankDetails.accountNumber,
        bankIFSCCode: bankDetails.ifscCode,
        bankBranchName: bankDetails.branchName,
        // isPasswordUpdated: null      // ! default null handled in supabase table
      },
    }
  );
  if (user) return user;
  else throw error;
}

async function addKYCDocFos(id, details) {
  const { data, error } = await supabase.from("KycDocuments").insert([
    {
      fosId: id,
      docType: "PanCard",
      docNumber: details.panNumber,
      docHolderName: details.panName.toUpperCase().replace(/\s\s+/g, " "),
      docUrl: "",
      otherDetails: details.panObject,
    },
    {
      fosId: id,
      docType: "AadharCard",
      docNumber: details.aadharNumber,
      docHolderName: details.aadharName,
      docUrl: "",
      otherDetails: details.aadharObject,
    },
  ]);
  if (data) return data;
  else throw error;
}

async function getCpBillingName(name) {
  const { data, error } = await supabase
    .from("CP")
    .select("cpId,billingName")
    .ilike("billingName", `%${name}%`)
    .eq("approvalStatus", "approved");
  // .eq('cpType', 'Entity')
  if (data) return data;
  else throw error;
}

// async function getUniquePanNumber(panNumber) {
//   console.log(panNumber);
//   const { data, error } = await supabase
//     .from('KycDocuments')
//     .select('*')
//     .eq('docType', 'PanCard')
//     .eq('docNumber', panNumber.toUpperCase())
//     .or('cpId.not.is.null,fosId.not.is.null')

//   if (data) return data;
//   else throw error;
// }
async function checkForUniqueDocs(docNumber) {
  const { data, error } = await supabase
    .from("KycDocuments")
    .select("*")
    .eq("docNumber", docNumber)
    .eq("docType", "PanCard");
  // .is('leadId', null);
  if (data) return data;
  else throw error;
}
//base64
async function uploadFileToDb(fileName, file) {
  const { data, error } = await supabase.storage
    .from("kycdocuments")
    .upload("CpDocuments/" + fileName, decode(file), {
      contentType: "application/pdf",
    });
  if (data) return data;
  else throw error;
}

//check for CpContactPerson exist email or not on entering email
async function checkCPExists(emailId) {
  console.log(emailId);
  const { data, error } = await supabase
    .from("CpContactPerson")
    .select("*")
    .match({ email: emailId.toLowerCase() });
  if (data) return data;
  else throw error;
}
async function checkPhoneExistsApi(phone) {
  const { data, error } = await supabase
    .from("CpContactPerson")
    .select("*")
    .eq("contactNumber", Number(phone)); // ✅ correct column + numeric conversion

  if (data) return data;
  else throw error;
}

//check for FOS exist email or not on entering email
async function checkFOSExists(emailId) {
  const { data, error } = await supabase
    .from("FOS")
    .select("*")
    .match({ email: emailId.toLowerCase() });
  if (data) return data;
  else throw error;
}
async function getCPUId(billingName) {
  const { data, error } = await supabase
    .from("CP")
    .select("cpDisplayId")
    .match({ billingName: billingName });
  if (data) return data;
  else throw error;
}
async function getFOSId(emailId) {
  const { data, error } = await supabase
    .from("FOS")
    .select("fosDisplayId")
    .match({ email: emailId.toLowerCase() });
  if (data) return data;
  else throw error;
}
//check for billingName exist in cp table or not
async function checkPanNumberExists(docNumber) {
  const { data, error } = await supabase
    .from("KycDocuments")
    .select("*")
    .eq("docNumber", docNumber)
    .eq("docType", "PanCard");
  // .is('cpId', null);
  // .from('CP')
  // .select('billingName').match({ billingName: billingName })
  // return []
  if (data) return data;
  else throw error;
}
async function checkBillingNameExists(billingName) {
  const { data, error } = await supabase
    .from("CP")
    .select("billingName")
    .match({ billingName: billingName });
  if (data) return data;
  else throw error;
}
async function checkBillingNameExistsInFos(billingName) {
  const { data, error } = await supabase
    .from("FOS")
    .select("name")
    .match({ name: billingName });
  if (data) return data;
  else throw error;
}
async function signOut() {
  return await supabase.auth.signOut();
}
function handleErrors(error, page, data) {
  console.log(page, ":", error);
  if (
    error?.message?.includes("FetchError: Failed to fetch") ||
    error?.message?.includes("Network Error")
  ) {
    Network.getStatus().then((resp) => {
      if (resp.connected) {
        offlineToast();
      } else {
        errorTost("Something went wrong!");
      }
    });
  } else {
    if (
      error?.message?.includes(
        'duplicate key value violates unique constraint "CP_billingName_key"'
      )
    ) {
      errorTost(`CP with Billing Name ${data} already exists`);
    } else if (error?.message?.includes("User already registered")) {
      errorTost("Contact Person email already exists");
    } else if (error?.message?.includes("BlacklistNumbers_number_key")) {
      errorTost("Number is blacklisted");
    } else if (
      error?.message?.includes(
        "You must provide either an email, phone number, a third-party provider or OpenID Connect."
      )
    ) {
      errorTost("Invalid Credentials");
    } else {
      errorTost(error.message);
    }
  }
}
async function getLatestCPData(cpId) {
  const { data, error } = await supabase
    .from("CpContactPerson")
    .select("*,cpId(*)")
    .eq("cpId", cpId)
    .single();
  if (data) return data;
  else throw error;
}
async function getLatestFOSData(fosId, cpId) {
  const { data, error } = await supabase
    .from("FOS")
    .select("*,cpId(*)")
    .eq("fosId", fosId)
    .eq("cpId", cpId)
    .single();
  if (data) return data;
  else throw error;
}
async function insertLoginLogs(obj) {
  const { data, error } = await supabase.from("LoginLogs").insert(obj);
  if (data) return data;
  else throw error;
}
// **for dev
async function LoginLogs() {
  const { data, error } = await supabase.from("LoginLogs").select("*");
  if (data) return data;
  else throw error;
}
async function authSignUp(postData) {
  return await supabase.auth.signUp(postData);
}

//* Users table
async function insertUser(postBody) {
  return await insertQuery("Users", postBody).select("*").maybeSingle();
}
function insertQuery(tableName, postData) {
  let _postBody = { ...postData };
  _postBody.last_updated_at = Date.now();

  return supabase.from(tableName).insert(_postBody);
}
async function resetPassword(access_token, newPassword) {
  const { data, error } = await supabase.auth.api.updateUser(access_token, {
    password: newPassword,
  });
  if (data) return data;
  else throw error;
}
async function sendResetPasswordMail(email) {
  const { data, error } = await supabase.auth.api.resetPasswordForEmail(email, {
    redirectTo: process.env.REACT_APP_CP_RESET_PASSWORD,
  });
  if (data) return data;
  else throw error;
}
async function getCPDetails(email) {
  const { data, error } = await supabase
    .from("CpContactPerson")
    .select("*,cpId(*)")
    .eq("email", email);
  if (data) return data;
  else throw error;
}
async function getFosDetails(email) {
  const { data, error } = await supabase
    .from("FOS")
    .select("*")
    .eq("email", email);
  if (data) return data;
  else throw error;
}
//* Update Auth
async function authUpDateSignUp(postData) {
  return await supabase.auth.api.updateUser(
    JSON.parse(localStorage.getItem("supabase.auth.token")).currentSession
      .access_token,
    postData
  );
}

// async function checkPanNumberExistsUpdateCp(panNumber) {
//   const { data, error } = await supabase
//     .from("KycDocuments")
//     .select("cpId")
//     .eq("docType", "PanCard")
//     .eq("docNumber", panNumber);
//   return data || [];
// }



export {
  loginWithEmailPass,
  signOut,
  signUpCP,
  addKYCDoc,
  signUpFos,
  getCpBillingName,
  getCpId,
  addKYCDocFos,
  uploadFileToDb,
  checkCPIsAprroved,
  checkFOSIsAprroved,
  checkIsEmailExist,
  getSalesPerson,
  handleErrors,
  checkCPExists,
  checkFOSExists,
  getCPUId,
  getFOSId,
  checkPanNumberExists,
  checkBillingNameExists,
  checkBillingNameExistsInFos,
  checkForUniqueDocs,
  getLatestCPData,
  getLatestFOSData,
  insertLoginLogs,
  LoginLogs,
  updateRecommentdationToFoSTable,
  updatePasswordFlag,
  authSignUp,
  insertUser,
  resetPassword,
  checkIsEmailExistFP,
  sendResetPasswordMail,
  getCPDetails,
  getFosDetails,
  signUpStaticCP,
  authUpDateSignUp,
  checkPhoneExistsApi
// checkPanNumberExistsUpdateCp,
};